module.exports = __webpack_public_path__ + "static/services-cs-lastmile-1647f879f1d9e795f5dbac7cd35f2a4e.png";